import styled from "styled-components";
import greenCheckImage from "./img/green-check.png"
import { useContext } from "react";
import { PageContext } from "../../../Context/PageContext";
import Dashboard from "../../Dashboard/Dashboard";
import UserNotLogged from "../../Dashboard/DashboardItems/UserNotLogged";

function SuccessNewAccount() {

    const {setPage} = useContext(PageContext);

    return(
        <MasterContainer>
            <H1>Conta Criada! </H1>
            <Frase>
                Você acabou de criar sua conta com sucesso.<br/>
                Já pode se logar no menu conta.<br/><br/>

                Divirta-se em nosso servidor!
            </Frase>
            <GreenCheck bg={greenCheckImage}/>
            
            <MenuContaLink
            onClick={() => setPage(<UserNotLogged/>)}
            >Acessar Conta</MenuContaLink>
            
        </MasterContainer>
    )
}

export default SuccessNewAccount;

const MasterContainer = styled.div`
    background-color: white;
    border-radius: 10px;
    box-shadow: 5px 5px 0px 1px black;
    border: solid 1px black;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: white;
    background-color: rgba(56, 127, 189, 1);
    padding: 30px 50px;

`

const H1 = styled.span`
    font-size: 36pt;
    font-weight: bold;
    margin-bottom: 15px;
`

const Frase = styled.span`
    text-align: center;
    font-size: 14pt;
    margin-bottom: 10px;

`

const GreenCheck= styled.div`
    background-image: url('${props => props.bg}');
    background-size: cover;
    background-repeat: no-repeat;
    backrgound-position: center center;
    width: 50px;
    height: 50px;
    margin-top: 10px;
`

const MenuContaLink = styled.span`
    font-weight: bolder;
    font-size: 24pt;
    margin: 10px 0 10px 0;
    cursor: url('cursors0007.png'), pointer;
    transition: .2s ease-in-out;

    &:hover {
    scale: 1.1;
    }

    &:active {
        cursor: url('cursors0008.png'), pointer; 
     }
`
